import React from "react";
import { useTranslation } from "react-i18next";
import img1 from "../../assets/new images/heart.png";
import img2 from "../../assets/new images/Airobot.png";

export default function AiCareerSection() {
  const { t } = useTranslation();
  return (
    <section className="flex items-center justify-center py-20  bg-gradient-to-b from-[#f8fafc] to-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        {/* Outer soft card */}
        <div className="rounded-2xl border border-orange-100 bg-gradient-to-b from-[#EE5F2B]/5 to-[#293C560D]/5 shadow-[0_8px_30px_rgba(31,41,55,0.06)] px-6 sm:px-10 ">
          <div className="grid md:grid-cols-12 gap-12 items-center">
            {/* LEFT COLUMN - Text Content */}
            <div className="md:col-span-7">
              <h2 className="text-slate-800 font-bold text-3xl sm:text-4xl md:text-5xl leading-tight mb-6">
                {t("aiCareerSection.heading1")}
                <br className="hidden sm:block" />
                {t("aiCareerSection.heading2")}
              </h2>

              <p className="text-slate-600 text-lg sm:text-xl leading-relaxed max-w-2xl mb-8">
                {t("aiCareerSection.description")}
              </p>

              {/* CTA Button */}
              <button className="inline-flex items-center justify-center gap-3 bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white font-semibold px-8 py-4 rounded-xl shadow-lg shadow-orange-500/25 hover:shadow-orange-500/35 transition-all duration-200 group">
                {t("aiCareerSection.cta")}
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" className="group-hover:translate-x-1 transition-transform duration-200">
                  <path d="M13 5l7 7-7 7M5 12h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>

            {/* RIGHT COLUMN - Cards */}
            <div className="md:col-span-5">
              <div className="grid grid-cols-1 gap-6">
                {/* CARD 1 */}
         

           
                  {/* Icon */}
       
                    <img src={img2} alt={t("humanExpertise.card2Title")} className=" object-contain" />
    
           
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}